export const TEST_ID = {
  legalDocumentModal: 'legalDocumentModal',
};
